import {Space} from "antd";
import {ProductSubPricingCostFormField} from "./cost";

export function ProductSubPricingFormFields() {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ProductSubPricingCostFormField />
      </Space>
    </div>
  );
}
